
import {Controller as GroupController} from './group';
import Scroller from '../../vendor/perfectscrollbar/js/main.js';

class Controller extends GroupController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.updateCycle = 0;

    }

    init(renderer){
        super.init(renderer);
        let config = {
            swipePropagation: true,
            wheelPropagation: true,
            touchPropagation: true
        };
        if(this.data.scrollY == 'auto'){
            config.suppressScrollY = true;
        }
        if(this.data.scrollX == 'auto'){
            config.suppressScrollX = true;
        }
        if(this.data.minThumbSize){
            config.minScrollbarLength = this.data.minThumbSize;
        }
        Scroller.initialize(this.renderOutput.result, config);
    }
    
    render(renderer){
        super.render(renderer);
        if(this.updateCycle > 0){
            Scroller.update(this.renderOutput.result);
            this.updateCycle--;
            this.update(false); 
        }
    }

    reset(renderer){
        Scroller.destroy(this.renderOutput.result);
        super.reset(renderer);
    }

    remove(renderer, removeFromParent=true){
        Scroller.destroy(this.renderOutput.result);
        super.remove(renderer, removeFromParent);
    }

    updateScroller(){
        // Scroller.update(this.renderOutput.result);
        this.updateCycle = 10;
        this.update();
    }
    
}

// you can extend a blue print for a parent component by importing it
// and using let Blueprint = Object.assign(parentBlueprint, {my: 'settings'});

let Blueprint = {
    type: Controller,
    properties: { 
        data: {
            scrollY: 'auto',
            scrollX: 'auto',
            minThumbSize: false
        }  
    },
    events: {   },
    children: []
}

export default Blueprint;
export {Controller};
